<template>
	<div class="full" v-if="currentRow">
		<el-divider content-position="left">{{currentRow.stockCode}}</el-divider>
		
		<div class="flex voucher_container">
			<div style="margin-right: 20px;">
				<vue-qr style="position: relative;" v-if="ma" class="ma" :text="JSON.stringify(ma)" :size="300"
					:margin="0"></vue-qr>
			</div>
			<div>
				<el-button type="danger" size="mini" style="margin-bottom: 10px;margin-left: 5px;" @click="submit">保存</el-button>
				<upload v-model="file_path" :formCreateInject="true" />
			</div>
		</div>
	</div>
</template>
<style scoped>
	.voucher_container {
		flex-direction: row;
	}

	.ma {
		width: 140px;
		height: 140px;
	}
</style>
<script>
	import vueQr from 'vue-qr'
	import upload from '@_system/components/formcomponents/common/upload/index.vue'
	export default {
		props: {
			currentRow: {
				default: () => {
					return null
				}
			}
		},
		data() {
			return {
				file_path: [],
				ma: null,
			}
		},
		watch: {
			currentRow(e) {
				if (e) {
					let ma = {
						module: 'purchasevoucher',
						action: 'uploadvoucher',
						param: {
							relationid: e.id
						}
					}
					this.ma = ma					
					this.file_path = e.file_path ? e.file_path : []
				} else {
					this.ma = null
					this.file_path = []
				}
			}
		},
		computed: {

		},
		created() {

		},
		mounted() {

		},
		methods: {
			submit() {
				this.$api.purchasevoucher.uploadvoucher({
					id:this.currentRow.id,
					file_path: this.file_path
				}).then((res) => {
					this.$message.success('操作成功')
					this.$emit('uploadsuccess',res)
				})
			}
		},
		components: {
			upload,
			vueQr,
			
		}
	}
</script>